// extracted by mini-css-extract-plugin
module.exports = {"console-main":"Console_console-main__2zo4V"};